// ABOUTME: Smart wrapper for the Truck Settings entity — owns useTruckSettingsEntity and reports state via context.
// ABOUTME: Renders skeleton/error/form; no options computed yet (Slice 3 will add UoM options).
import React, {useMemo, useState, useEffect} from 'react'

import {useTruckSettingsEntity} from '../hooks/useTruckSettingsEntity'
import {useEntityFormContext, useRegisterEntityForm} from '../context/EntityFormContext'
import {EntityContentEmpty} from './EntityContentEmpty'
import {EntityContentError} from './EntityContentError'
import {EntityContentSkeleton} from './EntityContentSkeleton'
import {TruckSettingsForm} from './TruckSettingsForm'
import {uomRefsToOptions} from '../utils/entityCatalogOptions'

export const TruckSettingsEntityForm: React.FC = () => {
  const ctx = useEntityFormContext()
  const {config, isLoading, isFetching, error, isSaving, actions} = useTruckSettingsEntity({
    countryId: ctx.countryId,
    businessLine: ctx.businessLine,
    scopeId: ctx.selectedScopeId,
    pendingScope: ctx.pendingScope,
    rootScopeId: ctx.rootScopeId,
  })

  useRegisterEntityForm(actions, isSaving)

  const [stableResetKey, setStableResetKey] = useState(ctx.formResetKey)

  useEffect(() => {
    if (!isFetching) {
      setStableResetKey(ctx.formResetKey)
    }
  }, [ctx.formResetKey, isFetching])

  const catalogUoms = ctx.trucksOptions?.availableUnitsOfMeasure
  const uomOptions = useMemo(
    () => (config?.truckSizeUomOption ? [config.truckSizeUomOption] : uomRefsToOptions(catalogUoms)),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [config?.truckSizeUomOption, catalogUoms],
  )

  if (isLoading) return <EntityContentSkeleton />
  if (error) return <EntityContentError />
  if (!config) return <EntityContentEmpty />

  return (
    <TruckSettingsForm
      key={stableResetKey}
      config={config}
      isReadOnly={ctx.isReadOnly}
      onDirtyChange={ctx.onDirtyChange}
      onValidChange={ctx.onValidChange}
      onValuesChange={actions.handleValuesChange}
      uomOptions={uomOptions}
      isRootScope={ctx.selectedScopeId === ctx.rootScopeId}
      isTruckTypeSelectable={config.isTruckTypeSelectable ?? ctx.trucksOptions?.truckTypeSelectable ?? false}
    />
  )
}
